import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { toast } from 'react-toastify';
import firebase from './../../../firebase';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import FalconCardHeader from 'components/common/FalconCardHeader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const EditMailing = () => {
  const { id } = useParams();

  const [l, setL] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});

  useEffect(()=> {
    // firebase.auth().onAuthStateChanged((user) => {
      if (id)  {
        setL(true);
        firebase.firestore().collection('mailingslist').doc(id).get().then(doc => {
          if (doc){ 
            let d = doc.data()
            d.id = doc.id;
            setFormData(d) 
            setL(false);
          }
        })
      }else{setL(false);
        toast.error('Une erreur s\'est produite.');
      }
    // })
  }, [])

  const handleChange = e => { 
    let d = {... formData}; 
    d[e.target.name] = e.target.value; 
    setFormData(d); 
  };

  const handleSubmit = e => {
    e.preventDefault();  
    if (formData && formData.title && formData.id){
      const da = { 
        title:formData.title ,  
        update_At: new Date(), 
      }
      setLoading(true);
      firebase.firestore().collection('mailingslist').doc(formData.id).update(da).then((res) => {
        setLoading(false);
        toast.success('Mise à jour terminé');
      }).catch(err => {
        setLoading(false);
        toast.error('Une erreur s\'est produite.');
      })
    }else{
      toast.error('Veuillez remplir tout les champs.');
    }
  };

  return (
    <Card>
      <FalconCardHeader title="Edition de la liste d'email" />
     {l ? <p>Chargement...</p> : (
       <Card.Body className="bg-body-tertiary">
       <Form onSubmit={handleSubmit}>
         <Row className="mb-3 g-3">
           <Form.Group as={Col} lg={6} controlId="title">
             <Form.Label>Titre</Form.Label>
             <Form.Control
               type="text"
               placeholder="titre"
               value={formData.title}
               name="title"
               onChange={handleChange}
             />
           </Form.Group> 
         </Row> 
         
         <div className="text-end">
           <Button variant="primary" type="submit" disabled={loading}>
             {!loading ? 'Mise à jour': 'Chargement'}
           </Button>
         </div>
       </Form>
        
     </Card.Body>
     )}
    </Card>
  );
};

export default EditMailing;
